import type { CatalogMaterial } from '@api/vendor-portal';

/**
 * Materials for a picker: the name, and the unit that separates two similarly-named things.
 *
 * Never the id first. It led every option once, so all thirty-eight opened with the same thirty
 * characters and the part that tells them apart wrapped onto a third line.
 *
 * NOTHING TO GROUP OR LEAD WITH. The catalogue already holds only what this site may receive —
 * the server narrows it to the BOM of what the site makes and refuses anything else on receipt
 * — so every option here is one the site can actually use. An empty list means the site's
 * products have no BOM yet, and the screen says so rather than widening the picker.
 *
 * Shared by every material picker in the portal — inward and wastage — because two copies of
 * "how a material is named" would drift, and the day they did, the same drum would read
 * differently on two screens.
 */
export function buildMaterialOptions(
    materials: CatalogMaterial[],
): Array<{ value: string; label: string }> {
    return materials.map((material) => ({
        value: material.itemId,
        label: material.unit
            ? `${material.name} (${material.unit})`
            : material.name || material.itemId,
    }));
}
